function pxToRem(px, base = 16) {
  return `${px / base}rem`;
}

module.exports = pxToRem;
